import React, { useContext } from "react";
import Headroom from "react-headroom";
import "./Header.scss";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import StyleContext from "../../contexts/StyleContext";
import Logo from '../../assets/images/myb.svg';
import { Link } from "react-router-dom";
import { AiOutlineRollback } from 'react-icons/ai';

function Header({ outside, inProjectDetails }) {
  const { isDark } = useContext(StyleContext);
  return (
    <Headroom>
      <header className={isDark ? "dark-menu header" : "header"}>
        <Link to="/" className="logo">

          <div className="logo-container">
            <img src={Logo} alt="" />
          </div>
        </Link>
        <input className="menu-btn" type="checkbox" id="menu-btn" />
        <label
          className="menu-icon"
          htmlFor="menu-btn"
          style={{ color: "white" }}
        >
          <span className={isDark ? "navicon navicon-dark" : "navicon"}></span>
        </label>
        <ul className={isDark ? "dark-menu menu" : "menu"}>
          {
            outside ? <li>
              <Link to="/" style={{ display: 'flex', alignItems: 'center' }} onClick={() => window.scrollTo(0, 0)}>
                <AiOutlineRollback /> &nbsp;Back To Home
              </Link>
            </li> :
              inProjectDetails ? <li>
                <Link to="/projects" style={{ display: 'flex', alignItems: 'center' }} onClick={() => window.scrollTo(0, 0)}>
                  <AiOutlineRollback /> &nbsp;Back To All Projects
                </Link>
              </li>
                :
                <>
                  <li>
                    <a href="/#skills">Skills</a>
                  </li>
                  <li>
                    <a href="/#experience">Experiences</a>
                  </li>

                  <li>
                    <a href="/#projects">Projects</a>
                  </li>

                  <li>
                    <Link to="/about" onClick={() => window.scrollTo(0, 0)}>About Me</Link>
                  </li>
                  <li>
                    <a href="/#contact">Contact Me</a>
                  </li>
                </>
          }
          <li>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a>
              <ToggleSwitch />
            </a>
          </li>
        </ul>
      </header>
    </Headroom>
  );
}
export default Header;
